import { render, staticRenderFns } from "./CommentsBox.vue?vue&type=template&id=6106b8d2&scoped=true"
import script from "./CommentsBox.vue?vue&type=script&lang=js"
export * from "./CommentsBox.vue?vue&type=script&lang=js"
import style0 from "./CommentsBox.vue?vue&type=style&index=0&id=6106b8d2&prod&lang=scss"
import style1 from "./CommentsBox.vue?vue&type=style&index=1&id=6106b8d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6106b8d2",
  null
  
)

export default component.exports